import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function cssColorToHex(c: string): string {
  return c && c.startsWith("#") ? c : "#5865F2";
}

export function hexToInt(hex: string): number {
  const s = hex.replace("#", "").trim();
  if (!/^[0-9a-fA-F]{6}$/.test(s)) return 0x5865f2;
  return parseInt(s, 16);
}
